import { Link } from "react-router-dom";

const getNestedValue = (obj, key) => {
  return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : ""), obj);
};

const TableBody = ({ columns, tableData }) => {
  return (
    <tbody>
      {tableData.map((row, idx) => (
        <tr key={idx}>
          {columns.map(({ accessor,className }) => (
            <>
            {accessor == "network_val" ? (
              <td key={accessor} className={`px-4 py-2 border ${className}`}>
              <i class="fa-solid fa-wifi-slash offline-rms-icon" title="Site not updating" />
              </td>
            ) :
            
            accessor == "site_id" ? (
              <td key={accessor} className={`px-4 py-2 border ${className}`}>
                <Link className="fw-bold" to={`/site/${row[accessor]}`}>{row[accessor]}</Link>
              </td>
            ) : (
              <td key={accessor} className={`px-4 py-2 border ${className}`}>
                {getNestedValue(row, accessor)}
              </td>
            )
            
            }

            </>

          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default TableBody;